/* Models */
class AutoArriveConfigurationModel extends App.Models.BaseModel {
    modelUrl = 'AutoArriveConfiguration';
}

App.Models.AutoArriveConfiguration = AutoArriveConfigurationModel;

/* Collection */
class AutoArriveConfigurationCollection extends App.Collections.BaseCollection {
    url = 'AutoArriveConfiguration';
    model = App.Models.AutoArriveConfiguration;
}

App.Collections.AutoArriveConfigurations = AutoArriveConfigurationCollection;

/* Router */
class AutoArriveConfigurationRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'AutoArriveConfiguration';
        const model = App.Models.AutoArriveConfiguration;
        const collectionClass = App.Collections.AutoArriveConfigurations;

        super(entityName, model, collectionClass);
    }

    afterCreateForm = function (entity, formData, crudStage) {
        this.setupStartRouteCheckboxes();
        this.configureStartCompleteBasedOnFields(crudStage);
    }

    afterPopulateForm = function (model) {
        this.validateSmartTrackFields();
        this.setupStartRouteCheckboxes();
        this.setValueStartCompleteRouteBasedOn(model.attributes);
    }

    beforeUpdate = (form) => {
        this.treatStartCompleteTimesToBasedOnModel(form);
    }

    beforeCreate = (model) => {
        this.treatStartCompleteTimesToBasedOnModel(model.attributes);
    }

    beforePopulateLocalCollection = () => {
        var projection = JSON.parse(this.projection);
        projection.filters.splice(projection.filters.indexOf('aaConfig.times.options'), 1);
        projection.filters =  projection.filters.concat(['startAfterTimeSecs', 'completeAfterTimeSecs',
            'startBeforePlannedTimeSecs', 'completeBeforePlannedTimeSecs',
            'startBeforeBaseLineTimeSecs', 'completeBeforeBaseLineTimeSecs' ]);

        this.projection = JSON.stringify(projection);
    }

    treatStartCompleteTimesToBasedOnModel = (model) => {
        const option = model['aaConfig.times.options'];
        let atributeToStart = 'startAfterTimeSecs';
        let atributeToComplete = 'completeAfterTimeSecs';

        if(option !== 'FIXED') {
            if(option === 'PLANNED') {
                atributeToStart = 'startBeforePlannedTimeSecs';
                atributeToComplete = 'completeBeforePlannedTimeSecs';
            } else if(option === 'BASELINE') {
                atributeToStart = 'startBeforeBaseLineTimeSecs';
                atributeToComplete = 'completeBeforeBaseLineTimeSecs';
            }

            model.startBeforePlannedTimeSecs = null;
            model.completeBeforePlannedTimeSecs = null;
            model.startBeforeBaseLineTimeSecs = null;
            model.completeBeforeBaseLineTimeSecs = null;
            model[atributeToStart] = model.startAfterTimeSecs;
            model[atributeToComplete] = model.completeAfterTimeSecs;
            model.startAfterTimeSecs = null;
            model.completeAfterTimeSecs = null;
        }
        delete model['aaConfig.times.options'];
    }

    setValueStartCompleteRouteBasedOn = (model) => {
        const form = App.Forms.AutoArriveConfiguration.form;
        const optionsField = form.fields['aaConfig.times.options'];
        let type;
        let valueToStart;
        let valueToComplete;

        if(model.startAfterTimeSecs || model.completeAfterTimeSecs) {
            type = 'FIXED';
            valueToStart = model.startAfterTimeSecs;
            valueToComplete = model.completeAfterTimeSecs;
        } else if(model.startBeforePlannedTimeSecs || model.completeBeforePlannedTimeSecs) {
            type = 'PLANNED';
            valueToStart = model.startBeforePlannedTimeSecs;
            valueToComplete = model.completeBeforePlannedTimeSecs;
        } else if(model.startBeforeBaseLineTimeSecs || model.completeBeforeBaseLineTimeSecs) {
            type = 'BASELINE';
            valueToStart = model.startBeforeBaseLineTimeSecs;
            valueToComplete = model.completeBeforeBaseLineTimeSecs;
        }
        optionsField.setValue(type);
        form.fields.startAfterTimeSecs.setValue(valueToStart);
        form.fields.completeAfterTimeSecs.setValue(valueToComplete);

        this.changeLabel(form, optionsField.getOptionSelected().label.innerHTML);
    }

    changeLabel =  (form, value) => {
        const resources = {
            start: 'aaConfigtimes.startime',
            complete: 'aaConfigtimes.complete'
        };
        form.fields.startAfterTimeSecs.label.innerHTML = Monet.I18n.getResourcesByKey(resources.start, value);
        form.fields.completeAfterTimeSecs.label.innerHTML = Monet.I18n.getResourcesByKey(resources.complete, value);
    }

    configureStartCompleteBasedOnFields = (crudStage) => {
        const form = App.Forms.AutoArriveConfiguration.form;
        const optionsField = form.fields['aaConfig.times.options'];
        const options = optionsField.getRadioButtons();
        const section = form.rootEl.querySelector('[key="pls_'+ crudStage+ '_start_after_time_autoArriveConfiguration"] .MonetUIFormSectionFields');

        section.insertBefore(section.querySelector('.optionGroup'), section.childNodes[0]);
        this.changeLabel(form, optionsField.getOptionSelected().label.innerHTML);

        options.forEach((item) => {
            item.input.addEventListener('click', (e) => {
                this.changeLabel(form, e.target.parentElement.querySelector('label').innerHTML);
            });
        });
    }

    setupStartRouteCheckboxes = function () {
        var allowStartRoute = document.querySelector("#AutoArriveConfiguration_allowStartRoute [name='allowStartRoute']");
        if (allowStartRoute) {
            this.toggleOnlyIfFromOriginCheckBox(allowStartRoute.checked);
            var clickListener = (function (scope) {
                return function (event) {
                    scope.toggleOnlyIfFromOriginCheckBox(event.target.checked);
                };
            }(this));
            allowStartRoute.removeEventListener("click", clickListener);
            allowStartRoute.addEventListener("click", clickListener, false);
        }
    }

    toggleOnlyIfFromOriginCheckBox = function (enabled) {
        var onlyStartIfDepartedFromOrigin = document.querySelector("#AutoArriveConfiguration_onlyStartIfDepartedFromOrigin [name='onlyStartIfDepartedFromOrigin']");
        onlyStartIfDepartedFromOrigin.disabled = !enabled;
        if (!enabled) {
            onlyStartIfDepartedFromOrigin.checked = false;
        }
    }

    validateSmartTrackFields = function () {
        var addStops = document.querySelector("#AutoArriveConfiguration_addStopsAutomatically [name='addStopsAutomatically']");
        if (addStops) {
            var shouldEnableFields = addStops.checked;
            this.disableSmartTrackFields(!shouldEnableFields);

            addStops.addEventListener("click", (function (scope) {
                return function (event) {
                    if (event.target.checked) {
                        scope.disableSmartTrackFields(false);
                    } else {
                        scope.disableSmartTrackFields(true);
                    }
                };
            }(this)), false);
        }
    }

    disableSmartTrackFields = function (enabled) {
        var onlyDriversLocations = document.querySelector("#AutoArriveConfiguration_addOnlyDriverLocations [name='addOnlyDriverLocations']");
        var searchLocations = document.querySelector("#AutoArriveConfiguration_searchLocationsWithinRadius [name='searchLocationsWithinRadius']");
        onlyDriversLocations.disabled = enabled;
        searchLocations.disabled = enabled;
    }

    afterCreate = () => {
        App.Objects.RouteDetails.shouldUpdateAll(true);
        window.location = "#/AutoArriveConfiguration";
    }
}

App.Routers.AutoArriveConfiguration = AutoArriveConfigurationRouter;
